/**
 * Stamp external links inside a container with target="_blank" and
 * rel="noopener noreferrer" so they open in a new tab without sending a
 * Referer header or exposing window.opener.
 *
 * Plain content links (no existing classes, i.e. markdown-generated) also get
 * the .article-external-link class (styled in assets/css/custom.css) for the
 * modern link look. Buttons, badges and Leaflet map attribution links keep
 * their own look.
 *
 * Idempotent — call from componentDidMount AND componentDidUpdate with a ref
 * to the component's container element, so links rendered after async loads
 * are covered too.
 */
export function decorateExternalLinks(container) {
    if (!container) {
        return;
    }
    const links = container.querySelectorAll('a[href^="http"]');
    links.forEach(link => {
        if (link.hostname && link.hostname !== window.location.hostname) {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
            if ((link.classList.length === 0 || link.classList.contains('article-external-link')) && !link.closest('.leaflet-container')) {
                link.classList.add('article-external-link');
            }
        }
    });
}

export default { decorateExternalLinks };
